import React, { useEffect, useState } from "react";
import { Button, Spin, Result, List } from "antd";
import { getGanadoresPublic } from "../../api/sorteo";
import { ExamLabel } from "../../components/commons";
import * as SHARED from "../../utils/shared";

function SorteoPublicGanadores(props) {
  const codigosorteo = props.match.params.codigo;
  const [dataToTable, setDataToTable] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState(null);
  const [recordSorteo, setRecordSorteo] = useState({
    nombre: ""
  });

  const fetchDataToTable = async () => {
    try {
      setIsLoading(true);
      const res = await getGanadoresPublic(codigosorteo);
      setDataToTable(res.payload.ganadores);
      setRecordSorteo(res.payload.sorteo);
    } catch (error) {
      setError(error);
      setIsError(true);
      setDataToTable([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchDataToTable();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) {
    return <Spin tip="Cargando" className="w-full py-60" />;
  }

  if (isError) {
    return (
      <Result
        status="500"
        title="Algo salió mal"
        subTitle={error.message}
        extra={
          <Button onClick={() => window.location.reload()} type="primary">
            Recargar
          </Button>
        }
      />
    );
  }

  return (
    <div className="max-w-md mx-auto">
      <div className="max-w-sm mx-auto">
        <ExamLabel
          firstTitle={`RESULTADOS DE SORTEO`}
          mainTitle={SHARED.PROCESO}
          style={{ background: "#D41D3D" }}
        />

        <div className="mb-5 text-center">
          <h3 className="text-base font-bold ">{recordSorteo.nombre}</h3>

          <p className="text-xs font-semibold mt-2">
            CÓDIGO DE SORTEO: <span className="text-blue-400">{codigosorteo}</span>
          </p>
        </div>
      </div>

      <List
        size="small"
        bordered
        dataSource={dataToTable}
        renderItem={(item) => (
          <List.Item>
            <List.Item.Meta
              title={
                <p>
                  {item.nrodocumento} - {item.apellido} {item.nombre}
                </p>
              }
            />
          </List.Item>
        )}
      />
    </div>
  );
}

export default SorteoPublicGanadores;
